// @ts-nocheck

import React, {useState, useEffect } from 'react';
import { Notification } from './notification.js';

// Interface for notification button
interface NotificationButton {
	title: string;
	action: () => void;
	className?: string;
}

// Interface for API response
interface ApiResponse {
	err?: string;
}

// Interface for component props
interface InfoBtnProps {
	display?: boolean;
	confirm?: boolean;
	infoBtn?: string;
	displayInfo?: () => void;
}

export const InfoBtn = ( props: InfoBtnProps ) => {
	const [ visible, setVisible ] = useState<boolean>( false );
	const [ error, setError ] = useState<string | false>( false );

	const logout = (): void => {

		fetch( "/user/logout/api" )
			.then(( response: Response ) => {
				return response.json();})
			.then(( response: ApiResponse ) => {

				if( response.err )
					setError( response.err );

				setVisible( false );

				if( !response.err )
					window.location.reload();

			}).catch(( err: Error ) => {
			setError( err.message );
		});
	};


	return (
	<div>
		<p className={"info-btn" +
			(props.display ? " display-flex": "") +
			(props.confirm ?  " confirm": " "  ) }

		   onClick={() => setVisible( true ) }
		   onMouseDown={props.displayInfo}
		>{props.infoBtn}</p>

		<Notification
			title={ "Log out" }
			text={ "Are you sure?" }
			buttons={[ { title: "Log Out", action: logout } as NotificationButton ]}
			toggle={ visible }
			visible={{ action: setVisible }}
		/>
		<Notification
			className={ "server-error" }
			title={ "Error" }
			text={ error }
			toggle={ error }
			visible={{ action: setError }}
		/>
	</div>
	);
};